<ion-header mode="ios">
  <ion-toolbar color="secondary">
    <ion-title class="text-grey-ultra-dark">{{ 'pages.fund-cash.purchase.confirm.split.rowModal.title' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <form [formGroup]="form">
    <ion-list>
      <ui-form-field
        [control]="form.controls.amount"
        class="fs-16"
        lines="full"
        label="pages.fund-cash.purchase.confirm.split.rowModal.price"
      >
        <ion-input [formControl]="form.controls.amount" type="number" min="0.01" [max]="maxAmount"></ion-input>
      </ui-form-field>

      <ui-form-field
        [control]="form.controls.budgetItem"
        icon="chevron-forward"
        iconSlot="end"
        iconClasses="icon-end fs-16 pt-32"
        class="fs-16"
        lines="full"
        label="pages.fund-cash.purchase.confirm.split.rowModal.budgetItem"
      >
        <ui-budget-item-select
          [formControl]="form.controls.budgetItem"
          [project]="project"
          [projectTasks]="budgetProjectTasks"
          [allowedSubtasks]="allowedSubtasks"
          [articleFormControl]="form.controls.article"
        ></ui-budget-item-select>
      </ui-form-field>
    </ion-list>
  </form>
</ion-content>

<ui-bottom-actions>
  <div class="light-text text-center ion-margin-bottom">
    {{ 'pages.fund-cash.purchase.confirm.split.rowModal.maxAmount' | translate }} {{ maxAmount | currency: 'EUR':'symbol-narrow':'1.2' }}
  </div>
  <div class="flex flex-column gap-4">
    <ion-button color="primary" [disabled]="!form.valid" (click)="apply()">
      {{ 'pages.fund-cash.purchase.confirm.split.rowModal.confirm' | translate }}
    </ion-button>
  </div>
</ui-bottom-actions>
